import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ProyectoEscuelasParticipantesDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ProyectoEscuelasParticipantesService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private readonly http: HttpClient) {}

  getProyectoEscuelasParticipantesService(): Observable<
    BodyListResponse<ProyectoEscuelasParticipantesDTO>
  > {
    return this.http.get<BodyListResponse<ProyectoEscuelasParticipantesDTO>>(
      API_URL + '/api/v1/proyectoEscuelasParticipantes/todos',
    );
  }

  guardarProyectoEscuelasParticipantesService(
    proyectoEscuelasParticipantesDTO: ProyectoEscuelasParticipantesDTO,
  ): Observable<BodyResponse<ProyectoEscuelasParticipantesDTO>> {
    return this.http.post<BodyResponse<ProyectoEscuelasParticipantesDTO>>(
      API_URL + '/api/v1/proyectoEscuelasParticipantes',
      proyectoEscuelasParticipantesDTO,
    );
  }

  getProyectoEscuelasParticipantesPorCodigoService(
    codigo: string,
  ): Observable<BodyResponse<ProyectoEscuelasParticipantesDTO>> {
    return this.http.get<BodyResponse<ProyectoEscuelasParticipantesDTO>>(
      API_URL + '/api/v1/proyectoEscuelasParticipantes/' + codigo,
    );
  }
}
